/**
 *  Component: Guide Section
 */
import React from 'react';

import { Grid } from '@material-ui/core';
import styled from 'styled-components';

import SlackImage from 'assets/images/slackPlugin.jpeg';

import { NotificationIcon1, CheckMarkIcon, PaperIcon, CheckListIcon } from 'constants/icons';

import IconWithText from '../Jira/iconWithText';
import { FormContainer, FormHeading, Separator, Icon } from '../styles';

const GuideSection = () => (
  <FormContainer>
    <FormHeading>
      <Icon>
        <NotificationIcon1 size="fixed18px" />
      </Icon>
      On Mesh you'll get notified of the following
    </FormHeading>
    <Separator />
    <Container>
      <Grid container>
        <Grid xs="4" item container direction="column">
          <Grid>
            <IconWithText
              icon={<CheckMarkIcon size="smaller" color="#3A8EE9" />}
              text="Receive updates for any progress in a Mesh pod on a Slack channel"
            />
          </Grid>
          <Grid>
            <IconWithText
              icon={<PaperIcon size="smaller" color="#3A8EE9" />}
              text="Choose summary updates that you wish to receive daily/weekly"
            />
          </Grid>
          <Grid>
            <IconWithText
              icon={<CheckListIcon size="smaller" color="#3A8EE9" />}
              text="Know your pending tasks directly from Slack"
            />
          </Grid>
        </Grid>
        <Grid xs="8" item container direction="column" alignContent="flex-end">
          <StrokedImage src={SlackImage} alt="slack" />
        </Grid>
      </Grid>
    </Container>
  </FormContainer>
);

const Container = styled.div`
  padding: 2rem 2rem 30px 24px;
`;

const StrokedImage = styled.img`
  width: 95%;
  border: 1px solid #eee;
`;

export default GuideSection;
